import { Textarea } from "./ui/textarea";

const PLACEMENTS = [["auto", "Auto"], ["image", "On the image"], ["below", "Below the image"]];
const MAX = 500;

export const MessageField = ({ form, set }) => (
  <div data-testid="message-field">
    <Textarea
      data-testid="event-message-input"
      rows={4}
      maxLength={MAX}
      value={form.message}
      onChange={(e) => set("message")(e.target.value)}
      placeholder={"Dress code: festive!\nParking is on Elm St."}
      className="rounded-xl"
    />
    <p data-testid="event-message-count" className="mt-1 text-right text-xs text-slate-400">{form.message.length}/{MAX}</p>
  </div>
);

export const MessagePlacementPicker = ({ form, set }) => (
  <div data-testid="message-placement">
    <div className="inline-flex flex-wrap rounded-lg bg-slate-100 p-1" role="radiogroup">
      {PLACEMENTS.map(([v, label]) => (
        <button
          key={v}
          type="button"
          role="radio"
          aria-checked={form.message_placement === v}
          data-testid={`message-placement-${v}`}
          onClick={() => set("message_placement")(v)}
          className={`rounded-md px-3 py-1.5 text-xs font-semibold transition-[background-color,color] duration-200 ${
            form.message_placement === v ? "bg-white text-blue-700 shadow-sm" : "text-slate-500 hover:text-slate-800"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
    <p className="mt-2 text-xs text-slate-500">Auto puts it on the image when details are on the image, otherwise below.</p>
  </div>
);
